/**
 * HTTP 403 from the API (insufficient role permissions).
 */
export function isForbidden(error) {
  return error?.response?.status === 403;
}

export function accessDeniedMessage(error) {
  const msg = error?.response?.data?.message;
  return typeof msg === 'string' && msg.trim()
    ? msg.trim()
    : "You don't have permission to view or change this.";
}
